var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 86,
    viewBox: "0 0 87 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.889 37.6082C76.8484 54.3917 65.6417 70.3965 48.8581 73.3559L21.4886 78.1819C18.8037 78.6553 16.8819 75.6191 18.4429 73.3699L23.3327 66.3242C18.1365 61.8431 14.3948 55.6093 13.1104 48.3251C10.151 31.5415 21.3577 15.5367 38.1412 12.5773C54.9248 9.61795 70.9296 20.8246 73.889 37.6082ZM44.365 30.2804C44.0691 28.602 42.4753 27.4802 40.8053 27.7746C39.1353 28.0691 38.0214 29.6684 38.3174 31.3468L40.4608 43.5025C40.7567 45.1808 42.3504 46.3027 44.0204 46.0082C45.6904 45.7138 46.8043 44.1145 46.5084 42.4361L44.365 30.2804ZM45.0921 52.0861C43.4221 52.3805 42.3082 53.9798 42.6041 55.6582C42.9001 57.3365 44.4938 58.4584 46.1638 58.1639L46.194 58.1586C47.864 57.8641 48.9779 56.2648 48.682 54.5865C48.3861 52.9081 46.7923 51.7863 45.1223 52.0807L45.0921 52.0861Z",
    fill: "#FFC400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.654189f0b0feabb35b5f18068b6002cf.svg";
export { ForwardRef as ReactComponent };